import React, { useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/Button';
import { chargeInformation } from 'actions/stripe';
import Dialog from '@material-ui/core/Dialog';
import TextField from 'components/TextField';
import { json2xml } from 'utils/jsonToXmlParser';
import {
  submitOrderToCanada,
  submitOrderToUSA,
  updateOrderStatus,
  saveOrderData,
} from 'actions/orders';
import { ModalContainer, Footer } from 'styles/pages/my-stores/registration';

const XMLParser = require('react-xml-parser');

const OrderSubmitToProd = ({ open, setModal, order, hideAllModal }) => {
  const [transactionId, setTransactionId] = useState(null);
  const products = useSelector((state) => state?.products?.data);
  const auth = useSelector((state) => state?.auth);
  const token = useSelector((state) => state?.auth?.profile?.token);

  const dispatch = useDispatch();
  return (
    <Dialog maxWidth='md' open={open} onClose={() => setModal(false)}>
      <ModalContainer>
        <h1>Enter Transaction ID (Stripe) </h1>
        <TextField
          fullWidth
          placeholder='Transaction ID'
          value={transactionId || ''}
          onChange={(v) => setTransactionId(v)}
        />
        <Footer>
          <Button
            disabled={!transactionId}
            variant='text'
            title='Submit order to machine'
            onClick={async () => {
              const charge = await dispatch(
                chargeInformation({
                  transactionId,
                  emailid: order?.MasterUserEmail,
                  receiptId: order?.ReceiptID,
                })
              );
              if (charge?.error) {
                return;
              }

              const xml = json2xml(
                charge?.ShirtlyOrderData,
                products,
                order?.MasterUserEmail,
                auth
              );

              const submitOrderResponse =
                charge?.ShirtlyOrderData?.PrintProvider === 'CA'
                  ? await dispatch(
                      submitOrderToCanada(
                        xml?.replaceAll('&', ' and ')?.replace(/>\s+</g, '><'),
                        token
                      )
                    )
                  : await dispatch(
                      submitOrderToUSA(
                        xml?.replaceAll('&', ' and ')?.replace(/>\s+</g, '><'),
                        token
                      )
                    );

              const parseOrderResponse = new XMLParser().parseFromString(
                submitOrderResponse
              );

              const errorMessage =
                parseOrderResponse.getElementsByTagName('ErrorMessage');

              if (errorMessage?.length) {
                if (
                  !!errorMessage[0]?.value?.trim()?.length &&
                  !errorMessage[0]?.value?.includes(
                    'already exists in the Database'
                  )
                ) {
                  alert(errorMessage[0].value);
                  return;
                }
              }

              const orderStatus = await dispatch(
                await updateOrderStatus({
                  user: order?.MasterUserEmail,
                  orderId: charge?.ShirtlyOrderData?.ID,
                  status: charge?.ShirtlyOrderData?.Status,
                  productionDate: moment().format('YYYY-MM-DD'),
                })
              );

              await dispatch(
                saveOrderData({
                  orderData: {
                    OrderSubmitToProductionDate: moment().format('YYYY-MM-DD'),
                    ShirtlyOrderData: orderStatus,
                    StripeChargeInfo: charge?.StripeChargeInfo,
                    // DataForMachine: xml,
                  },
                })
              );

              setTransactionId(null);
              hideAllModal();
            }}
          />
        </Footer>
      </ModalContainer>
    </Dialog>
  );
};

export default OrderSubmitToProd;
